<template>
  <div>
    <div style>
      <v-layout wrap class="mb-2">
        <v-flex xs12 md12>{{ $t('Chatbot answers') }}</v-flex>
      </v-layout>
    </div>
    <div>
      <template v-for="i in answers.length">
        <transition
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:after-enter="afterEnter"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
          v-on:after-leave="afterLeave"
          :key="i"
        >
          <intent-manage-answer
            class="intent-group-item"
            v-show="currentAlternative == i - 1"
            v-model="answers[i - 1]"
            :indexAlternative="i"
          ></intent-manage-answer>
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import IntentManageAnswer from './IntentManageAnswer'
export default {
  props: ['value'],
  data() {
    return {
      currentAlternative: 0,
      answers: []
    }
  },
  components: {
    IntentManageAnswer
  },
  mounted() {
    if (this.value.length == 0) {
      this.answers = this.value
      this.answers.push([])
    } else {
      this.answers = this.value
    }
  },
  methods: {
    beforeEnter: function(el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function(el, done) {
      setTimeout(() => {
        el.style.height = '100%'
        setTimeout(() => {
          Velocity(el, { opacity: 1, translateY: '10px' }, { complete: done, duration: 500 })
        }, 100)
      }, 600)
    },
    afterEnter: function(el) {
      //
    },
    beforeLeave: function(el) {
      el.style.opacity = 1
      // el.style.maxHeight = 'none'
    },
    leave: function(el, done) {
      Velocity(el, { opacity: 0, translateY: '-10px' }, { complete: done, duration: 500 })
    },
    afterLeave: function(el) {
      // el.style.maxHeight = 0
    },
    nextAlternative: function() {
      if (this.currentAlternative + 1 === this.answers.length) {
        this.answers.push([])
      }
      this.currentAlternative += 1
      // this.updateIntent()
    }
  }
}
</script>

<style lang="scss" scoped>
.intent-group-item {
  transition: height ease 2s;
  -webkit-transition: height ease 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/view/flow/IntentManageAnswers.vue